/**
 * Chailease.SystemParameter.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DeliveryAverageRequestViewModel } from '../model/deliveryAverageRequestViewModel';
import { DeliveryAverageResponseViewModel } from '../model/deliveryAverageResponseViewModel';
import { GetListRequestMainViewModel } from '../model/getListRequestMainViewModel';
import { GetListResponseViewModel } from '../model/getListResponseViewModel';
import { ProblemDetails } from '../model/problemDetails';
import { SavePermissionPersonnelViewModel } from '../model/savePermissionPersonnelViewModel';
import { UpdateDesignatedSupplierRequest } from '../model/updateDesignatedSupplierRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReviewPermissionDealerService {

    protected basePath = 'http://ch-demo-apigw.chailease.com.tw/dev-backdoor/retail-system-parameter-service';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [Private] 取得 廠審派件均值
     * 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reviewPermissionDealerGetDeliveryAveragePost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public reviewPermissionDealerGetDeliveryAveragePost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public reviewPermissionDealerGetDeliveryAveragePost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public reviewPermissionDealerGetDeliveryAveragePost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/ReviewPermissionDealer/GetDeliveryAverage`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得 最新廠審派件均值
     * 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reviewPermissionDealerGetDeliveryLatestAveragePost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<DeliveryAverageResponseViewModel>;
    public reviewPermissionDealerGetDeliveryLatestAveragePost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeliveryAverageResponseViewModel>>;
    public reviewPermissionDealerGetDeliveryLatestAveragePost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeliveryAverageResponseViewModel>>;
    public reviewPermissionDealerGetDeliveryLatestAveragePost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeliveryAverageResponseViewModel>('post',`${this.basePath}/ReviewPermissionDealer/GetDeliveryLatestAverage`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得廠審批核人員列表
     * 
     * @param body 搜尋
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reviewPermissionDealerGetListPost(body?: GetListRequestMainViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<GetListResponseViewModel>;
    public reviewPermissionDealerGetListPost(body?: GetListRequestMainViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetListResponseViewModel>>;
    public reviewPermissionDealerGetListPost(body?: GetListRequestMainViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetListResponseViewModel>>;
    public reviewPermissionDealerGetListPost(body?: GetListRequestMainViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetListResponseViewModel>('post',`${this.basePath}/ReviewPermissionDealer/GetList`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 更新 廠審批核人員資料
     * 
     * @param body 搜尋
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reviewPermissionDealerSaveAsyncPost(body?: SavePermissionPersonnelViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public reviewPermissionDealerSaveAsyncPost(body?: SavePermissionPersonnelViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public reviewPermissionDealerSaveAsyncPost(body?: SavePermissionPersonnelViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public reviewPermissionDealerSaveAsyncPost(body?: SavePermissionPersonnelViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/ReviewPermissionDealer/SaveAsync`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 更新 廠審派件均值
     * 
     * @param body 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reviewPermissionDealerSaveDeliveryAveragePost(body?: DeliveryAverageRequestViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public reviewPermissionDealerSaveDeliveryAveragePost(body?: DeliveryAverageRequestViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public reviewPermissionDealerSaveDeliveryAveragePost(body?: DeliveryAverageRequestViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public reviewPermissionDealerSaveDeliveryAveragePost(body?: DeliveryAverageRequestViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/ReviewPermissionDealer/SaveDeliveryAverage`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 更新 廠審指定供應商
     * 
     * @param body 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reviewPermissionDealerUpdateDesignatedSupplierPost(body?: UpdateDesignatedSupplierRequest, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public reviewPermissionDealerUpdateDesignatedSupplierPost(body?: UpdateDesignatedSupplierRequest, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public reviewPermissionDealerUpdateDesignatedSupplierPost(body?: UpdateDesignatedSupplierRequest, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public reviewPermissionDealerUpdateDesignatedSupplierPost(body?: UpdateDesignatedSupplierRequest, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/ReviewPermissionDealer/UpdateDesignatedSupplier`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
